import { createContext, useContext, useState } from "react";

export const MockModeContext = createContext({
  mocks: {
    classroom: false,
  },
});

export const useMockMode = () => {
  const context = useContext(MockModeContext);
  if (!context) {
    throw new Error("useMockMode must be used within MockModeProvider");
  }
  return context;
};

/**
 * Check if a specific mock is enabled
 * @param {string} mockName - e.g., 'classroom'
 * @returns {boolean}
 */
export const useMock = (mockName) => {
  const { mocks } = useMockMode();
  return mocks[mockName] ?? false;
};

/**
 * Manage mock state
 * (Mock modes are determined at build time and frozen)
 * @returns {{mocks: Object}}
 */
export const useMockModeManager = () => {
  const initialMocks = {
    classroom: process.env.REACT_APP_USE_MOCK_CLASSROOM === "true",
  };

  // Freeze the state to avoid further changes
  const [mocks] = useState(Object.freeze(initialMocks));

  return Object.freeze({ mocks });
};
